/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IPersonWithEmail,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class CustomersAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_All(
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/customers/all`,
    })
  }
  public async get_ContactInfo(
    customer_id: any,
  ): Promise<IPersonWithEmail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/customers/${customer_id}/contact-info`,
    })
  }
  /****** POST methods *****/
  public async post_Search(
    customer_ids: number[],
  ): Promise<IPersonWithEmail[]> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/customers/search`,
      data: {
        customer_ids
      },
    })
  }
  /****** PUT methods *****/
  public async put_UpdateName(
    customer_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/customers/${customer_id}/name`,
      data: {
        name
      },
    })
  }
}()
